import CloseIcon from '@assets/images/icons/modal/close.svg?react'
import { actionUrls } from '@components/App/Modal/Import/components/TextWithAction'
import { IconLinkArrow } from '@lib/icons'
import { setFinishedCrawlerJob } from '@storeOld/reducers/crawler'
import cx from 'classnames'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import status from '../CrawlerStatus.module.scss'
import { useCrawlerRemoveJob } from '../hooks/useCrawlerRemoveJob'
import css from './CrawlerFailed.module.scss'

type CrawlerFailedProps = {
  jobUrl: string
  jobId: string
}

export const CrawlerFailed: React.FC<CrawlerFailedProps> = ({
  jobUrl,
  jobId,
}) => {
  const { loading, remove } = useCrawlerRemoveJob()
  const dispatch = useDispatch()

  useEffect(() => {
    remove(jobId)
  }, [])

  const close = () => {
    // @todo implement action
    // @ts-expect-error
    dispatch(setFinishedCrawlerJob(null))
  }

  return (
    <div className={cx(status.crawlerStatus, css.crawlerFailed)}>
      <div className={status.crawlerStatusMain}>
        <div className={status.crawlerStatusIcon}>
          <CloseIcon />
        </div>
        <div>
          <div>Crawl failed. Unfortunately, this URL cannot be crawled.</div>
          <div className={status.crawlerStatusDescription}>{jobUrl}</div>
        </div>
      </div>
      <a
        target="_blank"
        href={actionUrls.CRAWLER_ERRORS_DESCRIPTIONS}
        className={status.crawlerStatusLink}
        rel="noopener"
      >
        More in Help Center <IconLinkArrow />
      </a>
      {loading}
      <button
        disabled={loading}
        onClick={close}
        className={cx(status.crawlerStatusButton, css.crawlerFailedButton)}
      >
        Close
      </button>
    </div>
  )
}
